export const isApiError = error =>
  error && error.meta && !error.meta.refreshTokenError;
